//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {gsap} from 'gsap/dist/gsap'
import {ScrollTrigger} from 'gsap/dist/ScrollTrigger'

import ResponsiveImageStrapi from '@/components/modules/ResponsiveImageStrapi'

export default {
	components: {
		ResponsiveImageStrapi
	},
	props: {
		data: {
			type: Object,
			default: null,
		},
		pagedata: {
			type: Object,
			default: null,
		},
	},
	mounted() {
		// this.$nextTick(this.Intro)
	},
	methods: {
		Intro() {
			gsap.registerPlugin(ScrollTrigger);
			
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.$refs.ele,
					// start: "top center", // when the top of the trigger hits the top of the viewport
					// end: "+=500", // end after scrolling 500px beyond the start
					// markers: true
				}
			});
			tl.fromTo(this.$refs.title, {
					autoAlpha: 0,
					x: -500
				}, {
					delay: 1,
					duration: 0.5,
					autoAlpha: 1,
					x: 0
				})
				.fromTo(this.$refs.content, {
					autoAlpha: 0,
					x: -500
				}, {
					duration: 0.5,
					autoAlpha: 1,
					x: 0
				});
		},
	}
}

